import { render, staticRenderFns } from "./search.vue?vue&type=template&id=fa0e9754&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=fa0e9754&prod&lang=scss&scoped=true"
import style1 from "./search.vue?vue&type=style&index=1&id=fa0e9754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0e9754",
  null
  
)

export default component.exports